import React, { Component } from 'react';
import { connect } from 'react-redux'

import {
  togglePopinNewsletter,
  submitPopinNewsletter
} from '../../actions/popin';
import { countryCode } from '../../services/translator';

import Newsletter from 'ui-kit/src/components/Newsletter/Newsletter';
import Popin from 'ui-kit/src/components/Popin/Popin';

class StatefulPopinNewsletter extends Component {
  render() {
    return (<Popin
      closeCallback={this.props.closeCallback}
      isOpen={this.props.isPopinNewsletterOpen}
    >
      {!this.props.confirmation && (
        <Newsletter
          email={this.props.email}
          submitCallback={this.props.submitCallback}
          countryCode={countryCode}
        />
      )}
      {this.props.confirmation}
    </Popin>)
  }
}

const mapStateToProps = (state) => {
  return {
    confirmation: state.popin.confirmation,
    email: state.popin.newsletterEmail,
    isPopinNewsletterOpen: state.popin.isPopinNewsletterOpen
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeCallback: togglePopinNewsletter.bind(null, dispatch, false),
    submitCallback: submitPopinNewsletter.bind(null, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(StatefulPopinNewsletter);


// WEBPACK FOOTER //
// ./src/components/StatefulPopinNewsletter/StatefulPopinNewsletter.jsx